export function salonpageImageCaption(value: string) {
  const [prefix, ...captionParts] = value.split("/");
  const caption = captionParts.join("/").trim();

  return caption || prefix || "";
}
